module.exports = __webpack_public_path__ + "static/media/optmatch.243cd948.svg";